import { Address, ApiData } from 'scenes/common/types';
import { makeApiError, makeApiSuccess } from 'scenes/common/helpers/apiData';

import connector from 'api/http';
import config from 'shared/config';

const RESULTS_LIMIT = 10;

const addressApi = (baseUrl: string = config.baseUrls.BFF_BASE_URL) => {
  const server = connector(baseUrl);

  return {
    getAddresses: (query: string): Promise<ApiData<Address[]>> =>
      server
        .get('/address/lookup', {
          query: query.split(',').join(''),
          limit: RESULTS_LIMIT,
        })
        .then((addresses) =>
          addresses?.length > 0
            ? makeApiSuccess(addresses)
            : makeApiError<Address[]>('Address not found')
        )
        .catch((err) => makeApiError<Address[]>(err.message)),

    getLocalities: (query: string): Promise<ApiData<Address[]>> =>
      server
        .get('/address/locality/lookup', { query, limit: RESULTS_LIMIT })
        .then((localities) =>
          localities?.length > 0
            ? makeApiSuccess(localities)
            : makeApiError<Address[]>('Address not found')
        )
        .catch((err) => makeApiError<Address[]>(err.message)),
  };
};

export default addressApi;
